import 'react-md/dist/react-md.red-teal.min.css'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import red from '@material-ui/core/colors/red'
import lightGreen from '@material-ui/core/colors/lightGreen'
import './index.css'

export default {
  palette: {
    primary: red,
    secondary: {
      main: lightGreen[700]
    }
  }
}
